// extracted by css-extract-rspack-plugin
export default {"dot":"_dot_DQ6sK","disabled":"_disabled_A7I91","upgrade":"_upgrade_kl3NN","success":"_success_zFwFv","warning":"_warning_EhZhz","danger":"_danger_LMNPL","primary":"_primary__NHcm"};